// import axios from "axios";

// export const googleCaptchaAPIKey= process.env.REACT_APP_GOOGLE_FORM_CAPTACH;
// export const baseURL= process.env.REACT_APP_PRO_MODE;
// export const hondaLogo= process.env.REACT_APP_HONDA_LOGO;
// export const maringLogo= process.env.REACT_APP_MARINE_LOGO;
// export const hiLogo= process.env.REACT_APP_HIPLUS_LOGO;


// const domain = process.env.REACT_APP_BASE_URL;

// export async function login(data) {
//   return await axios.post(`${domain}api/customer-login`, data);
// }
// export async function logoutcustomer(data) {
//   return await axios.post(`${domain}api/CustomerLogout`, data);
// }
// export async function loginVerifyOtp(data) {
//   return await axios.post(`${domain}api/customer-login-otp--verification`, data);
// }

// export async function customerSignup(data) {
//   return await axios.post(`${domain}api/customer-signup`, data);
// }

// export async function customerOTPVerify(data) {
//   return await axios.post(`${domain}api/customer-otp--verification`, data);
// }

// export  async function getCustomerProfile (data) {
//   return await axios.post(`${domain}api/get-customer-profile`, data);
// }
// export  async function updateCustomerProfile (data) {
//   return await axios.post(`${domain}api/update-customer-profile`, data);
// }

// export  async function getCountryList () {
//   return await axios.get(`${domain}api/GetCountryList`,);
// }

// export  async function getBannersList () {
//   return await axios.get(`${domain}api/GetBannersList`,);
// }


// export  async function getStateList (data) {
//   return await axios.post(`${domain}api/GetStateList`, data);
// }
// export  async function getCityList (data) {
//   return await axios.post(`${domain}api/GetCityList`, data);
// }
// export  async function getCustomerAddressList (data) {
//   return await axios.post(`${domain}api/get-customer-address-list`, data);
// }

// export  async function saveCustomerAddress (data) {
//   return await axios.post(`${domain}api/save-customer-address`, data);
// }
// export  async function updateCustomerAddress (data) {
//   return await axios.post(`${domain}api/update-customer-address`, data);
// }
// export  async function sendEmailVerification (data) {
//   return await axios.post(`${domain}api/send-email-verification`, data);
// }
// export  async function emailOTPVerification (data) {
//   return await axios.post(`${domain}api/email-otp-verification`, data);
// }
// export  async function deleteCustomerAddress (data) {
//   return await axios.post(`${domain}api/delete-customer-address`, data);
// }
// export  async function saveToWishList (data) {
//   return await axios.post(`${domain}api/save-to-wishlist`, data);
// }
// export  async function getWishListData (data) {
//   return await axios.post(`${domain}api/wishlist`, data);
// }
// export  async function getJobsList () {
//   return await axios.get(`${domain}api/GetJobsList`);
// }
// export  async function getPressList () {
//   return await axios.get(`${domain}api/PressList`);
// }
// export  async function pressDetails (data) {
//   return await axios.post(`${domain}api/PressDetails`, data);
// }

// export  async function getEventList () {
//   return await axios.get(`${domain}api/EventList`);
// }
// export  async function getEventLists (data) {
//   return await axios.post(`${domain}api/EventsList`,data);
// }
// export  async function getAllEventLists (data) {
//   return await axios.post(`${domain}api/AllEventsList`,data);
// }


// export  async function eventDetails (data) {
//   return await axios.post(`${domain}api/EventDetails`, data);
// }
// export  async function getVideoList () {
//   return await axios.get(`${domain}api/VideoList`);
// }

// export  async function getBlogsList () {
//   return await axios.post(`${domain}api/BlogsList`);
// }
// export  async function blogDetails (data) {
//   return await axios.post(`${domain}api/BlogsDetails`, data);
// }

// export  async function jobApply (data) {
//   return await axios.post(`${domain}api/JobApply`, data);
// }
// export  async function getDealerListByZipCode (data) {
//   return await axios.post(`${domain}api/GetDealerListByZipCode`, data);
// }
// export  async function getCategoryDetails (data) {
//   return await axios.post(`${domain}api/GetCategoryDetails`, data);
// }
// export  async function getOEMCategoryDetails (data) {
//   return await axios.post(`${domain}api/GetOEMCategoryDetails`, data);
// }

// export  async function getProductList (data) {
//   return await axios.post(`${domain}api/GetProductList`, data);
// }
// export  async function getOEMProductList (data) {
//   return await axios.post(`${domain}api/GetOEMProductList`, data);
// }

// export  async function getProductDetails (data) {
//   return await axios.post(`${domain}api/GetProductDetails`, data);
// }
// export  async function getOEMProductDetails (data) {
//   return await axios.post(`${domain}api/GetOEMProductDetails`, data);
// }

// export  async function getProductStock (data) {
//   return await axios.post(`${domain}api/GetProductStock`, data);
// }
// export  async function getProductStockAndPrice (data) {
//   return await axios.post(`${domain}api/GetProductStockAndPrice`, data);
// }
// export  async function submitCustomerCart (data) {
//   return await axios.post(`${domain}api/SubmitCustomerCart`, data);
// }

// export  async function checkoutValidate (data) {
//   return await axios.post(`${domain}api/CheckoutValidate`, data);
// }

// export  async function getInvestorDocumentList (data) {
//   return await axios.post(`${domain}api/GetInvestorDocumentList`, data);
// }
// export  async function getOrderStatus (data) {
//   return await axios.post(`${domain}api/GetOrderStatus`, data);
// }
// export  async function searchProducts (data) {
//   return await axios.post(`${domain}api/SearchProducts`, data);
// }
// export  async function compareProducts (data) {
//   return await axios.post(`${domain}api/CompareProducts`, data);
// }
// export  async function addCustomerBillingAddress (data) {
//   return await axios.post(`${domain}api/save-customer-billing-address`, data);
// }
// export  async function getCustomerBillingAddress (data) {
//   return await axios.post(`${domain}api/get-customer-billing-address-list`, data);
// }
// export  async function deleteCustomerBilling (data) {
//   return await axios.post(`${domain}api/delete-customer-billing-address`, data);
// }
// export  async function editCustomerBilling (data) {
//   return await axios.post(`${domain}api/update-customer-billing-address`, data);
// }
// export  async function getCustomerOrderList (data) {
//   return await axios.post(`${domain}api/GetCustomerOrderList`, data);
// }
// export  async function getCustomerOrderDetails (data) {
//   return await axios.post(`${domain}api/GetCustomerOrderDetails`, data);
// }
// export  async function productEnquiries (data) {
//   return await axios.post(`${domain}api/ProductEnquiries`, data);
// }
// export  async function oEMProductEnquiries (data) {
//   return await axios.post(`${domain}api/OEMProductEnquiries`, data);
// }

// export  async function getDealerCityList (data) {
//   return await axios.post(`${domain}api/GetDealerCityList`, data);
// }
// export  async function getDealerEnquiries (data) {
//   return await axios.post(`${domain}api/GetDealerEnquiries`, data);
// }
// export  async function offerApply (data) {
//   return await axios.post(`${domain}api/OfferApply`, data);
// }
// export  async function offerRemove (data) {
//   return await axios.post(`${domain}api/OfferRemove`, data);
// }
// export  async function orderCencel (data) {
//   return await axios.post(`${domain}api/OrderCencel`, data);
// }

// export  async function notifyMe (data) {
//   return await axios.post(`${domain}api/NotifyMe`, data);
// }
// export  async function becomeDealer (data) {
//   return await axios.post(`${domain}api/BecomeDealer`, data);
// }

// export  async function OEMRegistration (data) {
//   return await axios.post(`${domain}api/OEMRegistration`, data);
// }


// // export  async function getCategoryList () {
// //   return await axios.get(`${domain}api/GetCategoryList`,);
// // }
// export async function getCategoryList () {
//   let categoryData = '';
//    await axios.get(`${domain}api/GetCategoryList`).then((res) => {
//    switch (res.data.status) {
//        case 1:
//           categoryData = (res.data);
//        case 0:
//            break;
//        default:
//          return;
//    }
//  })
//  return categoryData;
// }
// export async function getOEMCategoryList () {
//   let categoryDataOem = '';
//    await axios.get(`${domain}api/GetOEMCategoryList`).then((res) => {
//    switch (res.data.status) {
//        case 1:
//         categoryDataOem = (res.data);
//        case 0:
//            break;
//        default:
//          return;
//    }
//  })
//  return categoryDataOem;
// }
// export async function getCommonAPIData () {
//   let resData = '';
//    await axios.get(`${domain}api/CommonAPI`).then((res) => {
//    switch (res.data.status) {
//        case 1:
//         resData = (res.data);
//        case 0:
//            break;
//        default:
//          return;
//    }
//  })
//  return resData;
// }

// export async function getCategoryListExport () {
//   let categoryData = '';
//    await axios.get(`${domain}api/GetExportCategoryList`).then((res) => {
//    switch (res.data.status) {
//        case 1:
//           categoryData = (res.data);
//        case 0:
//            break;
//        default:
//          return;
//    }
//  })
//  return categoryData;
// }
// export async function getInvestorCategoryList () {
//   let investorData = '';
//    await axios.get(`${domain}api/GetInvestorCategoryList`).then((res) => {
//    switch (res.data.status) {
//        case 1:
//         investorData = (res.data);
//        case 0:
//            break;
//        default:
//          return;
//    }
//  })
//  return investorData;
// }

// export  async function siteMap () {
//   return await axios.get(`${domain}api/SiteMap`);
// }

// export  async function GetDealerLocation () {
//   return await axios.get(`${domain}api/GetDealerLocation`);
// }

// export  async function GetDealerListByLocation (data) {
//   return await axios.post(`${domain}api/GetDealerListByLocation`, data);
// }

// export  async function getBoardOfDirectorsList () {
//   return await axios.get(`${domain}api/DirectorsList`);
// }



// export async function GetHomeProductList(data){
//   return await axios.get(`${domain}api/GetHomeProductList`,data)
// }


import axios from "axios";

export const googleCaptchaAPIKey= process.env.REACT_APP_GOOGLE_FORM_CAPTACH;
export const baseURL= process.env.REACT_APP_PRO_MODE;
export const hondaLogo= process.env.REACT_APP_HONDA_LOGO;
export const maringLogo= process.env.REACT_APP_MARINE_LOGO;
export const hiValuePlusLogo= process.env.REACT_APP_HIVALUEPLUS_LOGO;
export const hiLogo= process.env.REACT_APP_HIPLUS_LOGO;


const domain = process.env.REACT_APP_BASE_URL;

export async function login(data) {
  return await axios.post(`${domain}api/customer-login`, data);
}
export async function logoutcustomer(data) {
  return await axios.post(`${domain}api/CustomerLogout`, data);
}
export async function loginVerifyOtp(data) {
  return await axios.post(`${domain}api/customer-login-otp--verification`, data);
}

export async function customerSignup(data) {
  return await axios.post(`${domain}api/customer-signup`, data);
}

export async function customerOTPVerify(data) {
  return await axios.post(`${domain}api/customer-otp--verification`, data);
}

export  async function getCustomerProfile (data) {
  return await axios.post(`${domain}api/get-customer-profile`, data);
}
export  async function updateCustomerProfile (data) {
  return await axios.post(`${domain}api/update-customer-profile`, data);
}

export  async function getCountryList () {
  return await axios.get(`${domain}api/GetCountryList`,);
}

export  async function getBannersList () {
  return await axios.get(`${domain}api/GetBannersList`,);
}


export  async function getStateList (data) {
  return await axios.post(`${domain}api/GetStateList`, data);
}
export  async function getCityList (data) {
  return await axios.post(`${domain}api/GetCityList`, data);
}
export  async function getCustomerAddressList (data) {
  return await axios.post(`${domain}api/get-customer-address-list`, data);
}

export  async function saveCustomerAddress (data) {
  return await axios.post(`${domain}api/save-customer-address`, data);
}
export  async function updateCustomerAddress (data) {
  return await axios.post(`${domain}api/update-customer-address`, data);
}
export  async function sendEmailVerification (data) {
  return await axios.post(`${domain}api/send-email-verification`, data);
}
export  async function emailOTPVerification (data) {
  return await axios.post(`${domain}api/email-otp-verification`, data);
}
export  async function deleteCustomerAddress (data) {
  return await axios.post(`${domain}api/delete-customer-address`, data);
}
export  async function saveToWishList (data) {
  return await axios.post(`${domain}api/save-to-wishlist`, data);
}
export  async function getWishListData (data) {
  return await axios.post(`${domain}api/wishlist`, data);
}
export  async function getJobsList () {
  return await axios.get(`${domain}api/GetJobsList`);
}
export  async function getPressList () {
  return await axios.get(`${domain}api/PressList`);
}
export  async function pressDetails (data) {
  return await axios.post(`${domain}api/PressDetails`, data);
}

export  async function getEventList () {
  return await axios.get(`${domain}api/EventList`);
}
export  async function getEventLists (data) {
  return await axios.post(`${domain}api/EventsList`,data);
}
export  async function getAllEventLists (data) {
  return await axios.post(`${domain}api/AllEventsList`,data);
}


export  async function eventDetails (data) {
  return await axios.post(`${domain}api/EventDetails`, data);
}
export  async function getVideoList () {
  return await axios.get(`${domain}api/VideoList`);
}

export  async function getBlogsList () {
  return await axios.post(`${domain}api/BlogsList`);
}
export  async function blogDetails (data) {
  return await axios.post(`${domain}api/BlogsDetails`, data);
}

export  async function jobApply (data) {
  return await axios.post(`${domain}api/JobApply`, data);
}
export  async function getDealerListByZipCode (data) {
  return await axios.post(`${domain}api/GetDealerListByZipCode`, data);
}
export  async function getCategoryDetails (data) {
  return await axios.post(`${domain}api/GetCategoryDetails`, data);
}
export  async function getOEMCategoryDetails (data) {
  return await axios.post(`${domain}api/GetOEMCategoryDetails`, data);
}

export  async function getProductList (data) {
  return await axios.post(`${domain}api/GetProductList`, data);
}
export  async function getOEMProductList (data) {
  return await axios.post(`${domain}api/GetOEMProductList`, data);
}

export  async function getProductDetails (data) {
  return await axios.post(`${domain}api/GetProductDetails`, data);
}
export  async function getOEMProductDetails (data) {
  return await axios.post(`${domain}api/GetOEMProductDetails`, data);
}

export  async function getProductStock (data) {
  return await axios.post(`${domain}api/GetProductStock`, data);
}
export  async function getProductStockAndPrice (data) {
  return await axios.post(`${domain}api/GetProductStockAndPrice`, data);
}
export  async function submitCustomerCart (data) {
  return await axios.post(`${domain}api/SubmitCustomerCart`, data);
}

export  async function checkoutValidate (data) {
  return await axios.post(`${domain}api/CheckoutValidate`, data);
}

export  async function getInvestorDocumentList (data) {
  return await axios.post(`${domain}api/GetInvestorDocumentList`, data);
}
export  async function getOrderStatus (data) {
  return await axios.post(`${domain}api/GetOrderStatus`, data);
}
export  async function searchProducts (data) {
  return await axios.post(`${domain}api/SearchProducts`, data);
}
export  async function compareProducts (data) {
  return await axios.post(`${domain}api/CompareProducts`, data);
}
export  async function addCustomerBillingAddress (data) {
  return await axios.post(`${domain}api/save-customer-billing-address`, data);
}
export  async function getCustomerBillingAddress (data) {
  return await axios.post(`${domain}api/get-customer-billing-address-list`, data);
}
export  async function deleteCustomerBilling (data) {
  return await axios.post(`${domain}api/delete-customer-billing-address`, data);
}
export  async function editCustomerBilling (data) {
  return await axios.post(`${domain}api/update-customer-billing-address`, data);
}
export  async function getCustomerOrderList (data) {
  return await axios.post(`${domain}api/GetCustomerOrderList`, data);
}
export  async function getCustomerOrderDetails (data) {
  return await axios.post(`${domain}api/GetCustomerOrderDetails`, data);
}
export  async function productEnquiries (data) {
  return await axios.post(`${domain}api/ProductEnquiries`, data);
}
export  async function oEMProductEnquiries (data) {
  return await axios.post(`${domain}api/OEMProductEnquiries`, data);
}

export  async function getDealerCityList (data) {
  return await axios.post(`${domain}api/GetDealerCityList`, data);
}
export  async function getDealerEnquiries (data) {
  return await axios.post(`${domain}api/GetDealerEnquiries`, data);
}
export  async function offerApply (data) {
  return await axios.post(`${domain}api/OfferApply`, data);
}
export  async function offerRemove (data) {
  return await axios.post(`${domain}api/OfferRemove`, data);
}
export  async function orderCencel (data) {
  return await axios.post(`${domain}api/OrderCencel`, data);
}

export  async function notifyMe (data) {
  return await axios.post(`${domain}api/NotifyMe`, data);
}
export  async function becomeDealer (data) {
  return await axios.post(`${domain}api/BecomeDealer`, data);
}

export  async function OEMRegistration (data) {
  return await axios.post(`${domain}api/OEMRegistration`, data);
}


// export  async function getCategoryList () {
//   return await axios.get(`${domain}api/GetCategoryList`,);
// }
export async function getCategoryList () {
  let categoryData = '';
   await axios.get(`${domain}api/GetCategoryList`).then((res) => {
   switch (res.data.status) {
       case 1:
          categoryData = (res.data);
       case 0:
           break;
       default:
         return;
   }
 })
 return categoryData;
}
export async function getOEMCategoryList () {
  let categoryDataOem = '';
   await axios.get(`${domain}api/GetOEMCategoryList`).then((res) => {
   switch (res.data.status) {
       case 1:
        categoryDataOem = (res.data);
       case 0:
           break;
       default:
         return;
   }
 })
 return categoryDataOem;
}
export async function getCommonAPIData () {
  let resData = '';
   await axios.get(`${domain}api/CommonAPI`).then((res) => {
   switch (res.data.status) {
       case 1:
        resData = (res.data);
       case 0:
           break;
       default:
         return;
   }
 })
 return resData;
}

export async function getCategoryListExport () {
  let categoryData = '';
   await axios.get(`${domain}api/GetExportCategoryList`).then((res) => {
   switch (res.data.status) {
       case 1:
          categoryData = (res.data);
       case 0:
           break;
       default:
         return;
   }
 })
 return categoryData;
}
export async function getInvestorCategoryList () {
  let investorData = '';
   await axios.get(`${domain}api/GetInvestorCategoryList`).then((res) => {
   switch (res.data.status) {
       case 1:
        investorData = (res.data);
       case 0:
           break;
       default:
         return;
   }
 })
 return investorData;
}

export  async function siteMap () {
  return await axios.get(`${domain}api/SiteMap`);
}

export  async function GetDealerLocation () {
  return await axios.get(`${domain}api/GetDealerLocation`);
}

export  async function GetDealerListByLocation (data) {
  return await axios.post(`${domain}api/GetDealerListByLocation`, data);
}
export  async function GetHVPStateList () {
  return await axios.post(`${domain}api/HVPStateList`);
}
export  async function GetHVPCityList (data) {
  return await axios.post(`${domain}api/HVPCityList`,data);
}
export  async function GetHVPGetDealerCityList () {
  return await axios.post(`${domain}api/HVPGetDealerCityList`);
}
export  async function GetHiValuePlusHomePageData () {
  return await axios.post(`${domain}api/HVPHomePageAPI`);
}
export  async function GetHVPGetCategoryList () {
  return await axios.post(`${domain}api/HVPGetCategoryList`);
}
export  async function GetHVPGetSubCategoryList (data) {
  return await axios.post(`${domain}api/HVPGetSubCategoryList`, data);
}
export  async function GetHVPGetModelList (data) {
  return await axios.post(`${domain}api/HVPGetModelList`, data);
}
export  async function GetHVPGetALLModelList () {
  return await axios.post(`${domain}api/HVPGetALlModelList`);
}
export  async function SellProductByCustomer (data) {
  return await axios.post(`${domain}api/SellProductByCustomer`, data);
}
export  async function GetSellProductByCustomer (data) {
  return await axios.post(`${domain}api/GetSellProductByCustomer`, data);
}
export  async function GetSellProductByCustomerRequestList (data) {
  return await axios.post(`${domain}api/GetSellProductByCustomerRequestList`, data);
}
export  async function SellProductByCustomerSendOTP (data) {
  return await axios.post(`${domain}api/SellProductByCustomerSendOTP`, data);
}
export  async function SellProductByCustomerOTPVerify (data) {
  return await axios.post(`${domain}api/SellProductByCustomerOTPVerify`, data);
}
export  async function BuyProductByCustomerSendOTP (data) {
  return await axios.post(`${domain}api/BuyProductByCustomerSendOTP`, data);
}
export  async function BuyProductByCustomerOTPVerify (data) {
  return await axios.post(`${domain}api/BuyProductByCustomerOTPVerify`, data);
}
export  async function NotifyMeAPI (data) {
  return await axios.post(`${domain}api/NotifyMeAPI`, data);
}
export  async function NotifyMeOTPVerify (data) {
  return await axios.post(`${domain}api/NotifyMeOTPVerify`, data);
}
export  async function GetSellProductByCustomerDetails (data) {
  return await axios.post(`${domain}api/GetSellProductByCustomerDetails`, data);
}

export  async function getBoardOfDirectorsList () {
  return await axios.get(`${domain}api/DirectorsList`);
}

export async function getPriceCalculationCriteria (data) {
  return await axios.post(`${domain}api/GetPriceCalculationCriteria`,data);
}
export async function GetPriceCalculation (data) {
  return await axios.post(`${domain}api/GetPriceCalculation`,data);
}
export async function getHiValuePlusProductFilterList(){
  return await axios.post(`${domain}api/GetFiltersList`)
}
export async function getHVPGetProductsListAPI(data){
  return await axios.post(`${domain}api/HVPGetProductsListAPI`,data)
}
export async function HVPGetProductDetailsAPI(data){
  return await axios.post(`${domain}api/HVPGetProductDetailsAPI`,data)
}
export async function SellProductByCustomerToMoreDealer(data){
  return await axios.post(`${domain}api/SellProductByCustomerToMoreDealer`,data)
}
export async function SellProductByCustomerRequestToMoreDealer(data){
  return await axios.post(`${domain}api/SellProductByCustomerRequestToMoreDealer`,data)
}
export async function GetHomeProductList(data){
  return await axios.get(`${domain}api/GetHomeProductList`,data)
}
export async function GetBuyProductRequest(data){
  return await axios.post(`${domain}api/GetBuyProductRequest`,data)
}


